import { render, staticRenderFns } from "./dataV.vue?vue&type=template&id=82106dc0&scoped=true&"
import script from "./dataV.vue?vue&type=script&lang=js&"
export * from "./dataV.vue?vue&type=script&lang=js&"
import style0 from "./dataV.vue?vue&type=style&index=0&id=82106dc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82106dc0",
  null
  
)

export default component.exports